/**
 * BR-16 — 客户端显式埋点（走 `POST /api/v1/consumer/behavior/track`，事件名必须落在服务端白名单）。
 */
import { trackConsumerBehavior } from '@/lib/api';

const CLIENT_WHITELIST = new Set<string>([
  'VIEW_MERCHANT',
  'VIEW_GROUPON_DEAL',
  'VIEW_DISCOVER_POST',
  'SEARCH_QUERY',
  'ORDER_PLACED',
]);

/**
 * 失败静默：不阻塞 UI；服务端仍会校验白名单与鉴权。
 */
export async function trackBehavior(
  eventName: string,
  payload: Record<string, unknown> | undefined,
  token: string | null | undefined,
): Promise<void> {
  if (!token || !CLIENT_WHITELIST.has(eventName)) return;
  try {
    await trackConsumerBehavior({ eventName, payload }, token);
  } catch {
    /* ignore */
  }
}
